export default __webpack_public_path__ + "./images/sm.fc5e7d81.png";